<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    @if (editForm) {
        <form
            (ngSubmit)="save()"
            [formGroup]="editForm"
            [windeDisableFormControls]="viewInReadOnly ? editForm : null"
            class="dialog-form"
            name="editForm"
        >
            <div class="siklu-mat-dialog-title" matDialogTitle>
                <h4>{{ 'project.home.createOrEditBOMLabel' | translate }}</h4>
                <button matDialogClose windeClose>
                    <sui-svg-icon icon="cross" />
                </button>
            </div>
            <div class="siklu-mat-dialog-body" matDialogContent>
                <winde-alert-error></winde-alert-error>
                <winde-validation-alert
                    [(showAlert)]="showFormValidationAlert"
                    [messageObservable]="alertMessageSubject.asObservable()"
                ></winde-validation-alert>
                <div class="form-group">
                    <span class="form-label">{{ 'project.name' | translate }}</span>
                    <input class="form-control" formControlName="name" id="field_name" maxlength="250" required type="text" />
                </div>
                <div class="form-group">
                    <span class="form-label">{{ 'project.description' | translate }}</span>
                    <input class="form-control" formControlName="description" id="field_description" maxlength="250" type="text" />
                </div>
                <div class="form-group row">
                    <span class="form-label col-3 mt-auto">Project units</span>
                    @if (logicalConfig.crs.properties.productUnits) {
                        <div class="col-8 row justify-content-start" style="padding-top: 6px">
                            <span class="col-auto mr-3">
                                <input
                                    [readonly]="viewInReadOnly"
                                    formControlName="productUnits"
                                    name="productUnits"
                                    type="radio"
                                    value="meter"
                                />
                                Meter
                            </span>
                            <span class="col-auto mr-3">
                                <input
                                    [readonly]="viewInReadOnly"
                                    formControlName="productUnits"
                                    name="productUnits"
                                    type="radio"
                                    value="feet"
                                />
                                Feet
                            </span>
                        </div>
                    }
                </div>
                @if (
                    logicalConfig &&
                    logicalConfig.crs.properties.selectedProductsPerLayer &&
                    logicalConfig.crs.properties.selectedProductsPerLayer[defaultLayer] &&
                    dialogProductsService.engineRadioList &&
                    dialogProductsService.mhProducts
                ) {
                    <winde-bom-select-product
                        [(productsIsValid)]="productsIsValid"
                        [engineRadioList]="dialogProductsService.engineRadioList"
                        [logicalTopology]="logicalConfig.crs.properties"
                        [mhProducts]="dialogProductsService.mhProducts"
                        [viewInReadOnly]="false"
                    >
                    </winde-bom-select-product>
                }
            </div>
            <div class="siklu-mat-dialog-footer justify-content-between flex-row-reverse" matDialogActions>
                <div>
                    <button matDialogClose windeTransparent>
                        <sui-svg-icon icon="cross" />
                        {{ 'entity.action.cancel' | translate }}
                    </button>
                    <button type="submit" windeGreen>
                        <sui-svg-icon icon="save" />
                        {{ (project.id || project.id === 0 ? 'entity.action.save' : 'entity.action.create') | translate }}
                    </button>
                </div>
                @if (!project.id) {
                    <sui-checkbox-component [(isChecked)]="shouldOpenProject" label="project.openAfter.create"></sui-checkbox-component>
                }
            </div>
        </form>
    }
</div>
